export default function ({ store }) {
  // 마지막 동기화 시각. focus가 짧은 간격으로 반복 발생해도
  // 쿨다운(30초) 안에서는 중복 호출하지 않기 위한 기준값.
  let lastSync = 0
  const COOLDOWN = 30000

  const isLoggedIn = () => {
    const mbMngNo = store.getters['session/getMbMngNo']
    return mbMngNo && mbMngNo !== 'undefined' && mbMngNo !== ''
  }

  // force=true: 쿨다운을 무시하고 즉시 동기화 (초기 로드, 로그인/로그아웃 등)
  const sync = (force = false) => {
    if (!isLoggedIn()) { return }
    if (!force && Date.now() - lastSync < COOLDOWN) { return }
    lastSync = Date.now()
    store.dispatch('anc/fetchAncList')
  }

  // 초기 로드
  sync(true)

  // HMR 중복 등록 방지: 이전 리스너 제거 후 재등록
  if (window.__ancFocusHandler) {
    window.removeEventListener('focus', window.__ancFocusHandler)
  }
  window.__ancFocusHandler = () => sync()
  window.addEventListener('focus', window.__ancFocusHandler)

  // mbMngNo 변경 감지 (로그인/로그아웃)
  // 이전 watcher 해제 후 재등록 (HMR 중복 방지)
  if (window.__ancUnwatch) {
    window.__ancUnwatch()
  }
  window.__ancUnwatch = store.watch(
    state => state.session.member.mbMngNo,
    (newMbMngNo, oldMbMngNo) => {
      if (newMbMngNo === oldMbMngNo) { return }

      if (isLoggedIn()) {
        // 로그인(또는 계정 전환): 즉시 최신 판매알림 목록 동기화
        sync(true)
      } else {
        // 로그아웃: sync()는 isLoggedIn() 가드에서 막히므로
        // 판매알림 목록을 직접 비우고 쿨다운 기준도 초기화한다.
        lastSync = 0
        store.commit('anc/SET_ANC_LIST', [])
      }

      // [DRNQ-2868] 사용자 변경 시 기획전 신청 상태 초기화
      store.commit('curation/CLEAR_APPLIED_STATES')
    }
  )
}
